import "./LinkManagerStyles.scss";

import React, { memo, useRef } from "react";
import { Overlay } from "react-bootstrap";

import { ManageLinkComponent } from "./ManageLinkComponent";
import { PrepareLinkComponent } from "./PrepareLinkComponent";

interface IProps {
  currentTarget: any;
  editor: any;
  closePopup: () => void;
  url?: string;
  setAsPrepareLink: () => void;
  inPopup: boolean;
}
const MAX_POPUP_WIDTH = 300;
const EditorOverlay: React.FC<IProps> = memo(
  ({ currentTarget, editor, closePopup, setAsPrepareLink }) => {
    const popupRef = useRef(null);
    const targetElCoords = currentTarget.element.getBoundingClientRect();
    const editorContainer = document.getElementById(
      "editor-wrapper",
    ) as HTMLElement;
    const editorCoords = editorContainer.getBoundingClientRect();
    const placement =
      targetElCoords.left - editorCoords.left < MAX_POPUP_WIDTH / 2
        ? "bottom-start"
        : "bottom";
    return (
      <Overlay
        target={currentTarget.element}
        show={true}
        placement={placement}
        container={editorContainer}
      >
        {({
          placement: _placement,
          arrowProps: _arrowProps,
          show: _show,
          popper: _popper,
          hasDoneInitialMeasure: _hasDoneInitialMeasure,
          ...props
        }) => (
          <div
            {...props}
            className="link-manager__popup"
            contentEditable={false}
          >
            <div ref={popupRef}>
              {currentTarget.type === "readyLink" ? (
                <ManageLinkComponent
                  closePopup={closePopup}
                  editor={editor}
                  url={currentTarget.element.href}
                  setAsPrepareLink={setAsPrepareLink}
                />
              ) : (
                <PrepareLinkComponent onCancel={closePopup} editor={editor} />
              )}
            </div>
          </div>
        )}
      </Overlay>
    );
  },
);

export { EditorOverlay };
